import { render, staticRenderFns } from "./PartsList.vue?vue&type=template&id=9f99f592&scoped=true&"
import script from "./PartsList.vue?vue&type=script&lang=js&"
export * from "./PartsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f99f592",
  null
  
)

export default component.exports